module.exports = __webpack_public_path__ + "img/BOPtekst.f1e21120.jpg";